import Vue from "vue";
import Vuex from "vuex";
import auth from "@/store/modules/auth";
import project from "@/store/modules/project";
import submission from "@/store/modules/submission";
import sample from "@/store/modules/sample";
import labcontext from "@/store/modules/laboratory-context";
import breadcrumb from "@/store/modules/breadcrumb";
import overlay from "@/store/modules/overlay";
import trashStore from "@/store/modules/trashStore";
import projectStore from "@/store/modules/projectStore";
import formInfo from "@/store/modules/formInfo";
import receiveStore from "@/store/modules/receiveStore";
import scheduleStore from "@/store/modules/scheduleStore";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    breadcrumb,
    formInfo,
    labcontext,
    overlay,
    project,
    projectStore,
    receiveStore,
    sample,
    scheduleStore,
    submission,
    trashStore
  }
});
